function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M11.2423 6.21289C5.04332 6.21289 0 11.2557 0 17.4541C0 23.6525 5.04332 28.6953 11.2423 28.6953C17.4412 28.6953 22.4845 23.6525 22.4845 17.4541C22.4845 11.2557 17.4412 6.21289 11.2423 6.21289Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.7149 6.21289C17.516 6.21289 12.4727 11.2557 12.4727 17.4541C12.4727 23.6525 17.516 28.6953 23.7149 28.6953C29.9138 28.6953 34.9572 23.6525 34.9572 17.4541C34.9572 11.2557 29.9138 6.21289 23.7149 6.21289Z",
  fill: "#FA8578"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.8516 21.1433C16.8516 20.5776 16.3932 20.1191 15.8275 20.1191H12.793C12.9666 20.8307 13.208 21.5159 13.5101 22.1674H15.8275C16.3932 22.1674 16.8516 21.7089 16.8516 21.1433Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.8514 14.4777C16.8514 13.9123 16.3929 13.4536 15.8273 13.4536H13.2091C12.9584 14.1094 12.7671 14.7943 12.6426 15.5019H15.8273C16.3929 15.5019 16.8514 15.0434 16.8514 14.4777Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.6688 17.8103C19.6688 17.2446 19.2101 16.7861 18.6447 16.7861H12.4929C12.4799 17.0072 12.4727 17.2297 12.4727 17.454C12.4727 17.9212 12.5017 18.3818 12.5575 18.8344H18.6447C19.2101 18.8344 19.6688 18.3759 19.6688 17.8103Z",
  fill: "white"
}));

var SvgMastercard = function SvgMastercard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMastercard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mastercard.10a074ed.svg";
export { ForwardRef as ReactComponent };